import {
    Button,
    __experimentalHStack as HStack,
    FlexBlock,
} from '@wordpress/components';
import { useURLParams } from '../../contexts/ParamsContext';
import { __ } from '@wordpress/i18n';
import {
    Icon,
    wordpress,
    grid,
    tool,
    settings,
    customPostType,
    category,
} from '@wordpress/icons';

const SiteEditorSidebar = () => {
    const { params, updateUrlParams } = useURLParams();

    // List of menu items
    const menuItems = [
        {
            label: __('Field Groups', 'voxycure-framework'),
            icon: grid,
            match: (view) =>
                !view || ['edit-group', 'new-group'].includes(view),
            urlParams: {},
        },
        {
            label: __('Post Types', 'voxycure-framework'),
            icon: customPostType,
            match: (view) =>
                ['post-types', 'edit-post-type', 'new-post-type'].includes(view),
            urlParams: { view: 'post-types' },
        },
        {
            label: __('Taxonomies', 'voxycure-framework'),
            icon: category,
            match: (view) =>
                ['taxonomies', 'edit-taxonomy', 'new-taxonomy'].includes(view),
            urlParams: { view: 'taxonomies' },
        },
        {
            label: __('Options Pages', 'voxycure-framework'),
            icon: settings,
            match: (view) =>
                ['options-pages', 'edit-options-page', 'new-options-page'].includes(view),
            urlParams: { view: 'options-pages' },
        },
        {
            label: __('Tools', 'voxycure-framework'),
            icon: tool,
            match: (view) => view === 'tools',
            urlParams: { view: 'tools' },
        },
    ];

    return (
        <aside className='voxycure-editor__sidebar' >
            <Button
                href="/wp-admin/"
                icon={<Icon icon={wordpress} />}
                className="voxy-white-btn"
            >
                <span>{__('Back to WP Dashboard', 'voxycure-framework')}</span>
            </Button>

            <nav style={{ flex: 1 }}>
                <ul style={{ padding: 0, listStyle: 'none' }}>
                    {menuItems.map((item, index) => (
                        <li
                            key={index}
                            className={`voxycure-sidebar-item ${item.match(params.view) ? 'active' : ''
                                }`}
                        >
                            <Button onClick={() => updateUrlParams(item.urlParams)}>
                                <HStack spacing={2}>
                                    <Icon icon={item.icon} />
                                    <FlexBlock>{item.label}</FlexBlock>
                                </HStack>
                            </Button>
                        </li>
                    ))}
                </ul>
            </nav>
        </aside>
    );
};

export default SiteEditorSidebar;
